<template>
  <div>
    <b-modal v-model="showModal" title="Confirmation">
      <p class="my-4">Are you sure you want to remove this consultant from the course?</p>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = 0">Cancel</b-button>
        <b-button variant="danger" @click="confirmRemoval">Confirm</b-button>
      </template>
    </b-modal>
    <b-modal
      dialog
      size="lg"
      title="Add consultant to course"
      v-model="addingconsultant"
      hide-footer
    >
      <b-alert v-model="alreadyBooked">
        This consultant is already booked on this course
      </b-alert>
      <b-form-group
      >
        <b-form-input
          v-model="consultantEMail"
          type="text"
          placeholder="Search e-mail address"
          @input="consultants_filter"
          autocomplete="off"
        >
        </b-form-input>
      </b-form-group>
      <b-table
        :items="searchConsultants"
        :fields="searchColumns"
        @row-clicked="consultant_add"
        style="cursor: pointer"
      >
      </b-table>
    </b-modal>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb v-show="routemeta.navbar" />
    <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 mx-auto my-2">
      <b-card class="border-0 px-0 mx-0 col-12">
        <b-card-title>
          <h2 class="text-primary">
            Course Bookings
          </h2>
        </b-card-title>
        <b-card-body class="mx-0 px-0 col-12">
          <b-form-group
            lable="Course" 
            class="pb-4"
          >
            <b-form-select
              :options="courseOptions"
              v-model="courseId"
              v-on:change="courseconsultants_get"
              placeholder="Select course"
            >
            </b-form-select>
          </b-form-group>
          <b-card 
            v-if="courseId!=0"
            class="border-0 px-0 mx-0 col-12"
          >
            <b-card-title>
              <div class="row px-0 mx-0">
              <div class="col-8">
                Booked consultants
              </div>
              <div
                class="col-4 text-right"
              >
                <b-button
                  @click="addconsultant"
                >
                  Add consultant
                </b-button>
              </div>
            </div>
            </b-card-title>
            <b-card-body class="px-0 mx-0 col-12">
              <b-table
                title="Booked consultants"
                :fields="consultantColumns"
                :items="courseconsultants"
              >
              <template v-slot:cell(actions)="data">
                <div class="pt-0 mt-0">
                  <b-button variant="danger" @click="removingConsultant = data.item.consultant_id;showModal = true">Remove</b-button>
                </div>
              </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-card-body>
      </b-card> 
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

const courseConsultantColumns = [
  {
    key: "consultant_id",
    sortable: true,
    label: "ID",

  },
  {
    key: "family_name",
    sortable: true,
    label: "Family name",

  },
  {
    key: "first_name",
    sortable: true,
    label: "First name",

  },
  {
    key: "email",
    sortable: true,
    label: "E-mail",

  },
  {
    key: "started_date",
    sortable: true,
    label: "Booking date",

  },
  {
    key: 'actions',
    sortable: false,
    label: '',
    tdClass: "pt-2",
  }
];

const searchConsultantColumns = [
{
    key: "id",
    sortable: true,
    label: "ID",
  },
  {
    key: "family_name",
    sortable: true,
    label: "Family name",
  },
  {
    key: "first_name",
    sortable: true,
    label: "First name",
  },
  {
    key: "email",
    sortable: true,
    label: "E-mail",
  },
]
export default {
  name: 'LearningHub',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      routemeta: this.$route.meta,
      courseOptions: [],
      courseId: 0,
      consultantColumns: courseConsultantColumns,
      courseconsultants: [],
      addingconsultant: false,
      addingconsultantId: 0,
      consultantEMail: '',
      searchConsultants: [],
      searchColumns: searchConsultantColumns,
      alreadyBooked: false,
      showModal: false,
      removingConsultant: 0,
    }
  },
  async created () {
    this.courses_get()
  },
  methods: {
    async confirmRemoval() {
      await this.$store.dispatch('elearningcoursebookings_remove', { courseId: this.courseId, consultantId: this.removingConsultant });
      this.courseconsultants_get();
      this.showModal = false;
    },
    async consultant_remove(item) {
      await this.$store.dispatch('elearningcoursebookings_remove', { courseId: this.courseId, consultantId: item.consultant_id })
      this.courseconsultants_get();
    },
    async addconsultant() {
      this.addingconsultantId = 0;
      this.consultantEMail = '',
      this.addingconsultant = true;
    },
    async saveconsultant() {
      const payload = {
        courseId: this.courseId,
        consultantId: this.addingconsultantId,
      }
    },
    async courses_get () {
      this.loading = true;
      const filter = {
        course_active: {
          operator: '=',
          value: 1
        }
      }
      const res = await this.$store.dispatch('records_readlist', { table_name: 'g_elearning_courses', filter })
      const courseOptions = res.data.result.map( r => {
        return {
            value: r.id,
            text: r.course_name
        }
      })
      this.courseOptions = [
        { value: 0, text: 'Please select a course'},
        ...courseOptions
      ]
    },
    async courseconsultants_get() {
      this.courseconsultants = [];
      const res = await  this.$store.dispatch('elearningcoursebookings_fetch', { course_id: this.courseId })
      this.courseconsultants = res.data.result;
    },
    consultants_filter: _.debounce(function () {
      setTimeout(
        function () {
          this.consultant_search();
        }.bind(this),
        500
      );
    }, 300),
    async consultant_search() {
      const filter = {
        email: {
          operator: ' LIKE ',
          value: `%${this.consultantEMail}%`
        }
      }
      const res = await this.$store.dispatch('records_readlist', { table_name: 'i_user', filter });
      this.searchConsultants = res.data.result;
    },
    async consultant_add(item) {
      const already = this.courseconsultants.find(c => c.consultant_id == item.id)
      if (!already) {
        this.addingconsultant = false;
        await this.$store.dispatch("elearningcoursebookings_add", { courseId: this.courseId, consultantId: item.id })
        this.courseconsultants_get();
      } else {
        this.alreadyBooked = true;
      }
    },
  }
}
</script>
<style>
</style>